import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "latest-forms form-list" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "form-icon-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-alt" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar-alt text-dark" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = {
  key: 0,
  class: "send-option mt-2"
}
const _hoisted_7 = { class: "send-to modal-wrap xl-size" }
const _hoisted_8 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_9 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_10 = { class: "modal-content" }
const _hoisted_11 = { class: "modal-header" }
const _hoisted_12 = { class: "d-block" }
const _hoisted_13 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_16 = { class: "modal-body" }
const _hoisted_17 = { class: "form-wrap pt-0" }
const _hoisted_18 = { disabled: "" }
const _hoisted_19 = { class: "modal-footer justify-content-between" }
const _hoisted_20 = {
  key: 0,
  class: "form-sender"
}
const _hoisted_21 = { class: "mb-0" }
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user mr-1" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Sent by : ")
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" on ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleComponent = _resolveComponent("TitleComponent")
  const _component_TextBoxComponent = _resolveComponent("TextBoxComponent")
  const _component_RadioButtonComponent = _resolveComponent("RadioButtonComponent")
  const _component_SelectOption = _resolveComponent("SelectOption")
  const _component_CheckBox = _resolveComponent("CheckBox")
  const _component_TextArea = _resolveComponent("TextArea")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("h5", null, _toDisplayString(_ctx.template.title), 1),
    _createVNode("p", null, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("span", _hoisted_5, _toDisplayString(_ctx.template.created_date), 1)
    ]),
    (_ctx.isUserStatus)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sendSelectedForm(_ctx.template))),
            href: "javascript:void(0)",
            class: "btn default-btn outline btn-sm"
          }, " Send to ")
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("h5", _hoisted_13, _toDisplayString(_ctx.state.data.FormData.title), 1),
                _createVNode("p", _hoisted_14, _toDisplayString(_ctx.state.data.FormData.description), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                "aria-label": "Close",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateModal && _ctx.hideTemplateModal(...args)))
              }, [
                _hoisted_15
              ])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode("form", null, [
                  _createVNode("fieldset", _hoisted_18, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.FormData
                        .elements, (element, elementIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "form-group",
                        key: elementIndex
                      }, [
                        (element.type === 'title')
                          ? (_openBlock(), _createBlock(_component_TitleComponent, {
                              key: 0,
                              title: element.title,
                              description: element.description,
                              editStatus: false
                            }, null, 8, ["title", "description"]))
                          : _createCommentVNode("", true),
                        (element.type === 'textbox')
                          ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                              key: 1,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true),
                        (element.type === 'radioButton')
                          ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                              key: 2,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true),
                        (element.type === 'single_select')
                          ? (_openBlock(), _createBlock(_component_SelectOption, {
                              key: 3,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true),
                        (element.type === 'checkBox')
                          ? (_openBlock(), _createBlock(_component_CheckBox, {
                              key: 4,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true),
                        (element.type === 'textArea')
                          ? (_openBlock(), _createBlock(_component_TextArea, {
                              key: 5,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_19, [
              (_ctx.state.data.FormData)
                ? (_openBlock(), _createBlock("div", _hoisted_20, [
                    _createVNode("p", _hoisted_21, [
                      _hoisted_22,
                      _hoisted_23,
                      (
                      _ctx.state.data.FormData.owner &&
                      _ctx.state.data.FormData.owner.created_by
                    )
                        ? (_openBlock(), _createBlock("span", _hoisted_24, _toDisplayString(_ctx.state.data.FormData.owner.created_by.email), 1))
                        : _createCommentVNode("", true),
                      _hoisted_25,
                      _createVNode("span", null, _toDisplayString(_ctx.state.data.FormData.created_date), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateModal && _ctx.hideTemplateModal(...args)))
              }, " Close ")
            ])
          ])
        ])
      ])
    ])
  ]))
}